import Vue from 'vue'
import axios from "axios";
const mainAxios = axios.create();
mainAxios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.prototype.$axios = mainAxios;
export {
    mainAxios
};